import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=40e5d27e&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=40e5d27e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e5d27e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40e5d27e')) {
      api.createRecord('40e5d27e', component.options)
    } else {
      api.reload('40e5d27e', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=40e5d27e&scoped=true&", function () {
      api.rerender('40e5d27e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Z0c27ByoltyX/JS/teamMember.vue"
export default component.exports